<template>
  <div class="password-strength-meter">
    <!-- Шкала силы -->
    <div class="strength-bar">
      <div 
        class="strength-bar-fill"
        :style="{
          width: `${fillWidth}%`,
          backgroundColor: color
        }"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { passwordStrength } from '@shared/lib'

interface Props {
  password: string
}

const props = defineProps<Props>()

const result = computed(() => {
  if (!props.password) {
    return {
      score: 0,
      level: 'VERY_WEAK',
    }
  }
  return passwordStrength.evaluate(props.password)
})

const color = computed(() => {
  return passwordStrength.getLevelColor(result.value.level as any)
})

const fillWidth = computed(() => {
  // Если пароль сильный (зеленый) - заполняем на 100%
  if (result.value.level === 'STRONG' || result.value.level === 'VERY_STRONG') {
    return 100
  }
  // Иначе используем обычный score
  return result.value.score
})
</script>

<style scoped lang="scss">
.password-strength-meter {
  @apply space-y-2 mt-2 mb-2;
}

.strength-bar {
  @apply w-full h-2 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden border border-gray-300 dark:border-gray-600;
}

.strength-bar-fill {
  @apply h-full transition-all duration-300 ease-out;
  min-width: 2px;
}
</style>

